import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.use(Antd);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
